<div style="padding: 10px">
    <div style="display: flex; justify-content: space-between">
        <h1 style="margin: auto auto auto 0">Votre sélection d'écran</h1>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div
        class="screenListContainer"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()"
        [scrollWindow]="false"
    >
        <ng-container *ngFor="let sl of screenList">
            <ng-container *ngFor="let face of sl.fAs">
                <app-map-item
                    [hasDateSelected]="hasDateSelected"
                    [screenItem]="sl"
                    [faceItem]="face"
                    [mapMode]="false"
                    [recapMode]="true"
                    (clickScreenFromMapOutput)="unselectScreen($event)"
                ></app-map-item>
            </ng-container>
        </ng-container>
    </div>

    @if (isListLoading && screenList?.length > 0) {
    <div class="loadingContainer">
        <mat-spinner [diameter]="50"></mat-spinner>
        <i>Chargement des écrans ...</i>
    </div>
    }
</div>
<div mat-dialog-actions class="dialogActions">
    <button (click)="emptyCart()" mat-stroked-button>
        <mat-icon>remove_shopping_cart</mat-icon>Vider le panier
    </button>
    <button mat-stroked-button mat-dialog-close>Fermer</button>
</div>
